const KEY_CODE = {
    enter: 13,
    esc: 27,
    tab: 9,
    shift: 16,
    ctrl: 17,
    alt: 18,
    space: 32,
    backspace: 8,
    arrowUp: 38,
    arrowDown: 40,
    arrowLeft: 37,
    arrowRight: 39,
    A: 65,
    a: 97,
    z: 122,
    Z: 90
};

export default KEY_CODE;
